
import TableTextInput from './TableTextInput'
import TableDateInput from './TableDateInput'
import TableJalaliDateInput from './TableJalaliDateInput'

import TableImageInput from './TableImageInput'
import TabelGlobalUserInput from './TabelGlobalUserInput'
import TablePhoneInput from './TablePhoneInput'
import TableMultiSelectInput from './TableMultiSelectInput'
import TableSelectInput from './TableSelectInput'
import TablePriceInput from './TablePriceInput'
// import TablePriceInput from './TablePriceInput'
import TableStatusIndicator from './TableStatusIndicator'
import TableProfitCalculator from './TableProfitCalculator'
import TableCalculator from './TableCalculator'
import TableNumberInput from './TableNumberInput'
import TableTextAreaInput from './TableTextAreaInput'
import TableSwitchInput from './TableSwitchInput'
import TableFileInput from './TableFileInput'
import TableEditorInput from './TableEditorInput'
import ProgressInput from '../inputs/ProgressInput'
import NumberInput from '../inputs/NumberInput'
import TableSlidesInput from './TableSlidesInput'
import TableProfessionalStatusInput from './TableProfessionalStatusInput'
import TableCheckboxBoolean from './TableCheckboxBoolean'
const inputComponents = {
    // PhoneInput:TableTextInput,
    NumberInput: NumberInput,
    PasswordInput: TableTextInput,
    TextInput: TableTextInput,
    SelectInput: TableSelectInput,
    TextAreaInput: TableTextInput,
    ProfileImageInput: TableTextInput,
    SelectListInput: TableTextInput,
    CheckboxInput: TableCheckboxBoolean,
    FromToInput: TableTextInput,
    PriceInput: TablePriceInput,
    SliderInput: TableTextInput,
    SlidesInput:TableSlidesInput,
    AdvancedSelectInput: TableSelectInput,
    MultiSelectInput: TableMultiSelectInput,
    ImageInput: TableImageInput,
    DateInput: TableDateInput,
    DateInputNew: TableDateInput,
    JalaliDateInput: TableJalaliDateInput,
    GlobalUserInput: TabelGlobalUserInput,
    PhoneInput: TablePhoneInput,
    SwitchInput: TableSwitchInput,
    NewStatusIndicator: TableStatusIndicator,
    StatusIndicator: TableStatusIndicator,
    ProfitCalculator: TableProfitCalculator,
    Calculator: TableCalculator,
    NumberInput: TableNumberInput,
    TextAreaInput: TableTextAreaInput,
    FileInput: TableFileInput,
    MultiLevelInput: TableMultiSelectInput,
    EditorInput: TableEditorInput,
    MultiTreeSelectAddListing: TableMultiSelectInput,
    ProgressInput: ProgressInput,
    ProfessionalStatusInput: TableProfessionalStatusInput,
}

export default (inputComponents);